/* =========================================================
   FILE: assets/amk-60k-final-2026.js  (FINAL + EFFECT PACK)
   - Top3 swipe + dots ONLY on mobile (<= 820px). Desktop = no dots, no horizontal scroll.
   - Reveal animations
   - Ladder bars auto-fill rank 6 (80%) -> rank 20 (10%)
   - Ticket calc (SPECIAL: >= 1000€ => 500 tickets)
   - Submit + Live Check with Google Apps Script endpoint
   - Popup open/close
   - NEW: 2028 Winnerboard effects (tilt + shine + winner pulse), Button ripple
   ========================================================= */

(function () {
  var root = document.querySelector('[data-amk60-root]');
  if (!root) return;

  // ========= CONFIG =========
  var API_ENDPOINT =
    'https://script.google.com/macros/s/AKfycbzYNPIwjzjnprtj6jyTepfDXSGeh0khxlSZRus9TzoEk389c4uQbCcmH0QxzO552BHC/exec';

  // ========= HELPERS =========
  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function parseAmount(val) {
    if (val == null) return 0;
    var s = String(val).trim().replace(/\./g, '').replace(',', '.');
    var n = Number(s);
    return Number.isFinite(n) ? n : 0;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function setMsg(el, text, type) {
    if (!el) return;
    el.textContent = text || '';
    el.classList.remove('is-success', 'is-error', 'is-info');
    if (type === 'success') el.classList.add('is-success');
    if (type === 'error') el.classList.add('is-error');
    if (type === 'info') el.classList.add('is-info');
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // ========= POPUP =========
  var popup = qs('#amk60-popup');
  var popupHighlight = qs('#amk60-popup-highlight');
  var popupMeta = qs('#amk60-popup-meta');

  function openPopup(highlightHtml, metaText) {
    if (!popup) return;
    if (popupHighlight) popupHighlight.innerHTML = highlightHtml || '';
    if (popupMeta) popupMeta.textContent = metaText || '';
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    document.documentElement.classList.add('amk60-noScroll');
  }

  function closePopup() {
    if (!popup) return;
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('amk60-noScroll');
  }

  qsa('[data-amk60-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  // ========= REVEAL =========
  (function initReveal() {
    var items = qsa('.amk60-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (el) { io.observe(el); });
  })();

  // ========= BUTTON RIPPLE (subtle premium click feedback) =========
  (function initButtonRipple() {
    if (prefersReducedMotion()) return;

    function onClick(e) {
      var btn = e.currentTarget;
      if (!btn) return;

      // ensure positioning
      if (getComputedStyle(btn).position === 'static') {
        btn.style.position = 'relative';
      }
      btn.style.overflow = 'hidden';

      var r = btn.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;

      var ripple = document.createElement('span');
      ripple.className = 'amk60-ripple';
      ripple.style.position = 'absolute';
      ripple.style.left = x + 'px';
      ripple.style.top = y + 'px';
      ripple.style.width = '12px';
      ripple.style.height = '12px';
      ripple.style.borderRadius = '999px';
      ripple.style.transform = 'translate(-50%,-50%) scale(1)';
      ripple.style.opacity = '0.0';
      ripple.style.pointerEvents = 'none';

      // gold-ish ripple (no CSS dependency)
      ripple.style.background = 'radial-gradient(circle, rgba(214,174,66,.55), rgba(214,174,66,0) 70%)';

      btn.appendChild(ripple);

      // animate
      requestAnimationFrame(function () {
        ripple.style.transition = 'transform 520ms ease, opacity 520ms ease';
        ripple.style.opacity = '1';
        ripple.style.transform = 'translate(-50%,-50%) scale(22)';
      });

      setTimeout(function () {
        ripple.style.opacity = '0';
      }, 240);

      setTimeout(function () {
        if (ripple && ripple.parentNode) ripple.parentNode.removeChild(ripple);
      }, 720);
    }

    qsa('.amk60-btn').forEach(function (btn) {
      if (btn.__amkRippleBound) return;
      btn.__amkRippleBound = true;
      btn.addEventListener('click', onClick);
    });
  })();

  // ========= TOP3 DOTS + SWIPE (MOBILE ONLY) =========
  (function initTop3() {
    var track = qs('#amk60Top3Track');
    var dotsWrap = qs('.amk60-top3__dots');
    if (!track || !dotsWrap) return;

    var mm = window.matchMedia('(max-width: 820px)');

    function removeDotsActive() {
      qsa('.amk60-dotBtn', dotsWrap).forEach(function (d) { d.classList.remove('is-active'); });
      var first = qs('.amk60-dotBtn', dotsWrap);
      if (first) first.classList.add('is-active');
    }

    function enableMobile() {
      dotsWrap.style.display = 'flex';
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';

      var cards = qsa('[data-top3-card]', track);
      if (!cards.length) cards = qsa('.amk60-prizeCard', track);

      var dots = qsa('.amk60-dotBtn', dotsWrap);

      function setActiveDot(i) {
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        if (dots[i]) dots[i].classList.add('is-active');
      }

      dots.forEach(function (btn) {
        if (btn.__amkBound) return;
        btn.__amkBound = true;

        btn.addEventListener('click', function () {
          var idx = Number(btn.getAttribute('data-dot') || 0);
          var card = cards[idx];
          if (!card) return;
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          setActiveDot(idx);
        });
      });

      if (!track.__amkScrollBound) {
        track.__amkScrollBound = true;
        var raf = null;

        track.addEventListener('scroll', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var rect = track.getBoundingClientRect();
            var centerX = rect.left + rect.width / 2;

            var bestIdx = 0;
            var bestDist = Infinity;

            cards.forEach(function (card, idx) {
              var r = card.getBoundingClientRect();
              var cx = r.left + r.width / 2;
              var dist = Math.abs(cx - centerX);
              if (dist < bestDist) { bestDist = dist; bestIdx = idx; }
            });

            setActiveDot(bestIdx);
          });
        }, { passive: true });
      }
    }

    function disableDesktop() {
      // important: kill any horizontal scroll state
      dotsWrap.style.display = 'none';
      track.style.overflow = 'visible';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = 0; // hard reset
      removeDotsActive();

      // prevent wheel/trackpad horizontal drift on desktop
      if (!track.__amkWheelGuard) {
        track.__amkWheelGuard = true;
        track.addEventListener('wheel', function (e) {
          // if somehow overflow exists due to CSS/theme, stop horizontal wheel drift
          if (!mm.matches && Math.abs(e.deltaX) > 0) {
            track.scrollLeft = 0;
          }
        }, { passive: true });
      }
    }

    function applyMode() {
      if (mm.matches) enableMobile();
      else disableDesktop();
    }

    applyMode();

    // Listen to MQ change (more reliable than resize spam)
    if (mm.addEventListener) mm.addEventListener('change', applyMode);
    else window.addEventListener('resize', applyMode);
  })();

  // ========= WINNERBOARD 2028 EFFECTS (Desktop only) =========
  (function initWinnerEffects() {
    if (prefersReducedMotion()) return;

    var isDesktop = window.matchMedia('(min-width: 821px)').matches;
    if (!isDesktop) return;

    var cards = qsa('.amk60-prizeCard');
    if (!cards.length) return;

    // Mark #1 as winner (based on rank text "01")
    cards.forEach(function (card) {
      var rankEl = qs('.amk60-prizeCard__rank', card);
      var rank = rankEl ? String(rankEl.textContent || '').trim() : '';
      if (rank === '01') card.classList.add('is-winner');
    });

    // Tilt + spotlight following cursor
    cards.forEach(function (card) {
      if (card.__amkTiltBound) return;
      card.__amkTiltBound = true;

      var raf = null;
      var last = { x: 0, y: 0, inside: false };

      function applyTilt() {
        raf = null;
        if (!last.inside) return;

        var rect = card.getBoundingClientRect();
        var px = (last.x - rect.left) / rect.width;
        var py = (last.y - rect.top) / rect.height;

        // tilt values
        var rotY = (px - 0.5) * 10; // left/right
        var rotX = (0.5 - py) * 8;  // up/down

        card.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) translateY(-2px)';
        card.style.transition = 'transform 60ms linear';

        // Spotlight (CSS-free): use a custom property
        card.style.setProperty('--amkSpotX', Math.round(px * 100) + '%');
        card.style.setProperty('--amkSpotY', Math.round(py * 100) + '%');
      }

      card.addEventListener('mousemove', function (e) {
        last.x = e.clientX;
        last.y = e.clientY;
        last.inside = true;

        if (!raf) raf = requestAnimationFrame(applyTilt);
      });

      card.addEventListener('mouseenter', function () {
        card.style.willChange = 'transform';
        card.classList.add('is-hover');
      });

      card.addEventListener('mouseleave', function () {
        last.inside = false;
        card.classList.remove('is-hover');
        card.style.transition = 'transform 240ms ease';
        card.style.transform = 'none';
        card.style.willChange = 'auto';
      });
    });

    // Inject a premium “winner pulse” + gold underline bar inside choice row (#1 only)
    cards.forEach(function (card) {
      if (!card.classList.contains('is-winner')) return;

      // small accent bar under choices
      var choice = qs('.amk60-prizeCard__choice', card);
      if (choice && !qs('.amk60-choiceBar', choice)) {
        var bar = document.createElement('div');
        bar.className = 'amk60-choiceBar';
        bar.style.marginTop = '10px';
        bar.style.height = '6px';
        bar.style.borderRadius = '999px';
        bar.style.background = 'linear-gradient(90deg, rgba(214,174,66,.15), rgba(214,174,66,.95), rgba(214,174,66,.15))';
        bar.style.boxShadow = '0 0 22px rgba(214,174,66,.28)';
        bar.style.opacity = '0.95';
        choice.appendChild(bar);
      }

      // pulse on card (CSS-free)
      if (!card.__amkWinnerPulse) {
        card.__amkWinnerPulse = true;

        var t0 = performance.now();
        function pulse(now) {
          var t = (now - t0) / 1000;
          // subtle breathing glow
          var glow = 0.18 + 0.10 * (0.5 + 0.5 * Math.sin(t * 1.6));
          card.style.boxShadow = '0 26px 76px rgba(0,0,0,.62), 0 0 0 1px rgba(214,174,66,' + (glow) + ')';
          requestAnimationFrame(pulse);
        }
        requestAnimationFrame(pulse);
      }
    });
  })();

  // ========= LADDER BAR FILL (6 => 80%, 20 => 10%) =========
  (function initLadderBars() {
    var ladder = qs('[data-ladder]');
    if (!ladder) return;

    var cards = qsa('.amk60-ladderCard', ladder);
    if (!cards.length) return;

    function percentForRank(rank) {
      var r = Number(rank);
      if (!Number.isFinite(r)) return 10;

      var startRank = 6, endRank = 20;
      var startPct = 80, endPct = 10;

      var t = (r - startRank) / (endRank - startRank);
      t = clamp(t, 0, 1);

      var pct = startPct + (endPct - startPct) * t;
      return clamp(Math.round(pct), 10, 80);
    }

    function apply() {
      cards.forEach(function (card, idx) {
        var fill = qs('.amk60-bar__fill', card);
        if (!fill) return;

        var rank = card.getAttribute('data-rank');
        if (!rank) rank = 6 + idx;

        var pct = percentForRank(rank);

        requestAnimationFrame(function () {
          fill.style.width = pct + '%';
          fill.setAttribute('aria-label', 'Fortschritt ' + pct + '%');
        });
      });
    }

    if (!('IntersectionObserver' in window)) {
      apply();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          apply();
          io.disconnect();
        }
      });
    }, { threshold: 0.12 });

    io.observe(ladder);
  })();

  // ========= TICKET CALC =========
  function calculateTickets(amount) {
    var a = parseAmount(amount);

    if (a >= 1000) return 500; // SPECIAL
    if (a >= 500) return 200;
    if (a >= 200) return 50;
    if (a >= 100) return 30;
    if (a >= 50) return 10;
    if (a >= 20) return 4;
    return 0;
  }

  // live ticket preview
  (function initLiveTicketPreview() {
    var amountInput = qs('#amk60-amount');
    var display = qs('#amk60-tickets-display');
    var hidden = qs('#amk60-tickets-hidden');
    if (!amountInput || !display || !hidden) return;

    function update() {
      var tickets = calculateTickets(amountInput.value);
      display.value = String(tickets);
      hidden.value = String(tickets);
    }

    amountInput.addEventListener('input', update);
    amountInput.addEventListener('change', update);
    update();
  })();

  // ========= SUBMIT FORM =========
  (function initSubmit() {
    var form = qs('#amk60-submit-form');
    if (!form) return;

    var msg = qs('#amk60-submit-msg');
    var confirmBox = qs('#amk60-confirm');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = (form.querySelector('input[name="email"]') || {}).value || '';
      var casino = (form.querySelector('select[name="casino"]') || {}).value || '';
      var name = (form.querySelector('input[name="name"]') || {}).value || '';
      var amountRaw = (form.querySelector('input[name="amount"]') || {}).value || '';

      email = String(email).trim();
      casino = String(casino).trim();
      name = String(name).trim();

      var amount = parseAmount(amountRaw);
      var tickets = calculateTickets(amount);

      if (!email || !casino || !amount) {
        setMsg(msg, 'Bitte fülle E-Mail, Casino und Betrag aus.', 'error');
        return;
      }
      if (!isValidEmail(email)) {
        setMsg(msg, 'Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
        return;
      }
      if (!confirmBox || !confirmBox.checked) {
        setMsg(msg, 'Bitte bestätige, dass du 18+ bist und die Teilnahmebedingungen akzeptierst.', 'error');
        return;
      }
      if (tickets <= 0) {
        setMsg(msg, 'Beträge unter 20€ erzeugen keine Tickets.', 'error');
        return;
      }

      setMsg(msg, 'Wird gespeichert...', 'info');

      var payload = {
        action: 'add',
        email: email,
        casino: casino,
        amount: amount,
        tickets: tickets,
        name: name,
        source: 'amk-60k-final-2026',
        created_at: new Date().toISOString(),
      };

      fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      })
        .then(function (res) { return res.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (data && data.status === 'success') {
            setMsg(msg, 'Gespeichert! Für diese Einzahlung: ' + tickets + ' Tickets.', 'success');

            var euro = amount.toFixed(2).replace('.', ',');
            openPopup(
              'Für <span>' + euro + '€</span> bekommst du <span>' + tickets + ' Tickets</span>.',
              'Die Tickets wurden erfolgreich gespeichert und sind im Live-Check sichtbar.'
            );

            form.reset();

            // reset ticket preview
            var display = qs('#amk60-tickets-display');
            var hidden = qs('#amk60-tickets-hidden');
            if (display) display.value = '0';
            if (hidden) hidden.value = '0';
          } else {
            setMsg(msg, 'Ups – Speichern fehlgeschlagen. Bitte später erneut versuchen.', 'error');
          }
        })
        .catch(function () {
          setMsg(msg, 'Ups – Verbindung fehlgeschlagen. Bitte später erneut versuchen.', 'error');
        });
    });
  })();

  // ========= CHECK FORM =========
  (function initCheck() {
    var form = qs('#amk60-check-form');
    if (!form) return;

    var msg = qs('#amk60-check-msg');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = (form.querySelector('input[name="email"]') || {}).value || '';
      var casino = (form.querySelector('select[name="casino"]') || {}).value || '';

      email = String(email).trim();
      casino = String(casino).trim();

      if (!email) {
        setMsg(msg, 'Bitte gib deine E-Mail-Adresse ein.', 'error');
        return;
      }
      if (!isValidEmail(email)) {
        setMsg(msg, 'Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
        return;
      }

      setMsg(msg, 'Tickets werden abgefragt...', 'info');

      var payload = { action: 'check', email: email, casino: casino };

      fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      })
        .then(function (res) { return res.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (!data || data.status !== 'success') {
            setMsg(msg, 'Keine Ticketdaten gefunden.', 'error');
            return;
          }

          var totalTickets = Number(data.totalTickets || 0);
          var totalAmount = Number(data.totalAmount || 0);
          var entryCount = Number(data.entryCount || 0);

          var info = 'Für ' + email;
          if (casino) info += ' bei ' + casino;
          info += ': ' + totalTickets + ' Tickets • ' +
            totalAmount.toFixed(2).replace('.', ',') + '€ • ' +
            entryCount + ' Einträge';

          setMsg(msg, info, 'success');

          openPopup(
            'Du hast aktuell <span>' + totalTickets + ' Tickets</span> im System.',
            'Gesamte qualifizierende Einzahlungen: ' +
              totalAmount.toFixed(2).replace('.', ',') +
              '€ • Anzahl Einzahlungen: ' + entryCount
          );
        })
        .catch(function () {
          setMsg(msg, 'Ticketabfrage gerade nicht möglich. Bitte später erneut versuchen.', 'error');
        });
    });
  })();

  // ========= Smooth anchor scroll =========
  (function initAnchorScroll() {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;

      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;

      var target = document.querySelector(id);
      if (!target) return;

      e.preventDefault();

      var top = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: top - 14, behavior: 'smooth' });
    });
  })();

})();